const StickyButtonWrapper = ({
  children
}) => {
  return <div className="z-60 fixed inset-x-0 bottom-0 mx-auto bg-white p-4 text-end [box-shadow:0_-4px_6px_rgba(0,0,0,0.1)] md:static md:bg-transparent md:px-0 md:shadow-none" data-sentry-component="StickyButtonWrapper" data-sentry-source-file="StickyButtonWrapper.jsx">
      {children}
    </div>;
};
export default StickyButtonWrapper;